import { useEffect, useState } from "react";
import { useDebounce } from "../../../Components/useDebounce";
import { CLIENT_FNO } from "../../../Configuration/API_URL";
import { AESEncryption, ApiResDecrypt, noDataFound } from "../../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import SmallLoader from "../../../Components/Common/smallLoader";
import Loader from "../../../Components/Common/Loader";
import LoaderForSearch from "../../../Components/Common/LoaderForSearch";
import { Button, Modal } from "react-bootstrap";
import { partner_Api } from "../../../Configuration/Partner_URL";
import { axiosSsoJson, axiosSsoJsonReserv1 } from "../../../CommonMethhods/axiosPartnerInterceptor";


export default function PartnerCommTable(props) {
    let gridVal = props.gridVal
    const [image, setImage] = useState();
    const [uploadedFiles, setUploadedFiles] = useState({})
    const [actionVal, setActionVal] = useState({});
    const [searchInput, setSearchInput] = useState("");
    const [searchField, setSerchField] = useState(false);
    const storeToken = localStorage.getItem("ssoToken");
    const [action, setAction] = useState("")
    const projectRole = JSON.parse(localStorage.getItem("project"));
    const value = projectRole.filter(item => item?.Name === "Cosmos");
    const valueAdmin = value.filter(item => item.Role.Name === "Admin")
    const getRole = valueAdmin[0]?.Role?.Name;
    const debouncedValue = useDebounce(searchInput, 1000);
    const [deactivate, setDeactivate] = useState(false)

    useEffect(() => {
        handleSearchChange(debouncedValue);
    }, [debouncedValue]);

     useEffect(()=>{
        if(props.checkTab!=="comission"){
            setSearchInput("")
           }
      },[props.checkTab])

    // const handleScroll = (e) => {
    //     const a = e.target;
    //     if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
    //         if (props.count != gridVal.length) {
    //             props.setPageTable((prev) => prev + 1);
    //             props.setScrollLoaderTable(true);
    //             props.setLoader(false);
    //             let offset = props.pageTable + 1
    //             props.getCommisionDataList("grid", searchInput, 10, offset);
    //         }
    //         else {
    //             props.setScrollLoaderTable(false);
    //         }
    //     }
    // };
    const handleScroll = (e) => {
        const target = e.target;

        // If already at the end, and not currently loading
        if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 1) {

            // Prevent further API calls when all data is loaded
            if (props.gridVal.length >= props.count) {
                props.setScrollLoaderTable(false);
                return;
            }

            // Prevent multiple simultaneous API calls
            if (props.scrollLoaderTable || props.loader) return;

            // Load next page
            props.setScrollLoaderTable(true);
            props.setLoader(false);

            const nextPage = props.pageTable + 1;
            props.setPageTable(nextPage);
            props.getCommisionDataList("grid", searchInput, 10, nextPage);
        }
    };

    const handleAction = (val, id) => {
        setAction(val)
        setActionVal(prevState => ({
            ...prevState,
            [id]: val
        }));
    }

    const handleSubmitDoc = (item, status) => {
        updateDocument(item, status)
    }
    const updateDocument = async (item, status) => {
        const formData = new FormData();
        formData.append("File", image);
        formData.append("Status", status);
        formData.append("Id", item?.id)

        try {
            const getRemark = await axiosSsoJson.post(
                CLIENT_FNO.Update_Document,
                formData,
            );

            const res = (getRemark?.data);
            if (res?.status === 0) {
                props.setPageTable("1")
                props.getCommisionDataList("grid", searchInput, 10, props.pageTable);
                setImage("")
                setUploadedFiles("")
                toast.success(res?.data);
                setAction("")
                setActionVal("")

            }
        } catch (error) {
            if (error?.request?.status == 401) {
                localStorage.clear("");
                // navigate("/");
            }
        }
    };
    const handleFileUpload = (e, index) => {
        if (e?.target?.files && e?.target?.files?.length > 0) {
            let file = e.target.files[0]
            if (e?.target?.files[0]) {
                const allowedTypes = ["application/pdf"];
                if (allowedTypes.includes(file.type)) {
                    let size = Math.round((e?.target?.files[0]?.size / 1024))
                    let fileExtension = e?.target?.files[0]?.name.split('.')

                    if (e?.target?.files[0]?.type && (fileExtension?.length > 2 || fileExtension?.length === 2) &&
                        !(e?.target?.files[0]?.type === 'application/pdf')) {
                        toast.error("File size limit is 5 mb and in  pdf format")
                    } else if (fileExtension[1] !== "pdf") {
                        toast.error("Invalid image name")
                    }
                    else if (size > 5120) {
                        toast.error("File size limit is 5 mb and in pdf format")
                    }
                    else {
                        setImage(e?.target?.files[0])

                        const file = e.target.files[0];
                        if (file) {
                            setUploadedFiles(
                                { [index]: file.name }
                            );
                        }
                    }
                }
                else {
                    toast.error("File size limit is 5 mb and in pdf format")
                }
            }

        }
    };

    // const handleSearchChange = (data) => {
    //     if (data) {
    //         props.getCommisionDataList("grid", data, -1, -1);
    //     }
    //     else if (searchField === true) {
    //         props.getCommisionDataList("grid", searchInput, 10, offset);
    //         //
    //     }
    //     props.setPageTable(1)

    // };
    const handleSearchChange = (data) => {
        if (data) {
            props.getCommisionDataList("grid", data, -1, -1);
        } else if (searchField === true) {
            props.getCommisionDataList("grid", searchInput, 10, 1);
        }
        props.setPageTable(1);
    }
    const onDownloadDoc = async (id) => {

        let payloadValue = {
            id: id
        };
        let encPayload = AESEncryption(payloadValue);
        try {
            const getRemark = await axiosSsoJsonReserv1.post(
                CLIENT_FNO.Download_Doc,
                `"${encPayload}"`,
            );

            const res = ApiResDecrypt(getRemark?.data);
            if (res?.status === 0) {
                window.open(
                    res?.data,
                    "_blank",
                    "noopener,noreferrer"
                );

            }
        } catch (error) {
            if (error?.request?.status == 401) {
                localStorage.clear("");
                // navigate("/");
            }
        }

    }
    const [data, setData] = useState({})
    const handleDeactivate = async (item) => {
        setDeactivate(true)
        setData(item)
    };
    const deactivatefunction = async () => {
        if (!data || data.status.toLowerCase() !== "active") return;
        try {
            const payload = {
                id: data?.id,
                status: "inactive",
            };

            const response = await axiosSsoJson.post(
                partner_Api.Updatestatus,
                // "https://uat-cosmos.bajajfinservsecurities.in/api/rm/partner/updatestatus",
                payload,
            );

            if (response?.data?.status === 0) {
                console.log(response?.data, "hfsedcgvjbfckjns");
                toast.success("Commission deactivated successfully!");
                setDeactivate(false)
                // Refresh list after status update
                props.getCommisionDataList("grid", searchInput, -1, -1);
            } else {
                toast.error(response?.data?.message || "Failed to deactivate commission");
            }
        } catch (error) {
            console.error("Error deactivating commission:", error);
            toast.error("Something went wrong. Please try again.");
        }
    }


    return (
        <>
            <div className='personal-page brokerage'>
                <div className='personal-wrapper'>
                    <div className='search-input-wrapper'>
                        <div className="rm-custom-dropdown">
                            {/* <img src={searchIcon} alt="search" /> */}

                            {/* <input
                                type="text"
                                name="search-text"
                                className="input-st ap"
                                maxLength={20}
                                // onInput={onlyNumber}
                                value={searchInput}
                                placeholder="Search here..."
                                autoComplete="off"
                                onChange={(e) => {
                                    setSearchInput(e?.target?.value?.replace(/\s+/g, " ").trimStart().toUpperCase())  
                                    setSerchField(true)
                                }}
                            /> */}
                            <input
                                type="text"
                                name="search-text"
                                className="input-st ap"
                                maxLength={20}
                                value={searchInput}
                                placeholder="Search here..."
                                autoComplete="off"
                                onChange={(e) => {
                                    let value = e.target.value.toUpperCase();
                                    // Prevent space as the first character
                                    if (value.startsWith(" ")) {
                                        value = value.trimStart();
                                    }
                                    setSearchInput(value);
                                    setSerchField(true);
                                }}
                                onInput={(e) => {
                                    const start = e.target.selectionStart;
                                    const end = e.target.selectionEnd;

                                    let input = e.target.value.toUpperCase();
                                    input = input.replace(/[^a-zA-Z0-9 ]/g, "");
                                            input = input.replace(/\s{2,}/g, " "); 
                                            input = input.replace(/^\s+/, ""); 

                                    if (input.length > 100) input = input.slice(0, 100);
                                    e.target.value = input;
                                    e.target.setSelectionRange(start, end);
                                    }}
                            />


                        </div>

                        <button className="dnload-btn" style={{ background: "#1C74D0", color: "#FFFFFF" }} onClick={() => { props.getCommisionDataList("excel", searchInput, -1, -1) }}>
                            {props.smallLoaderExcel ? (
                                <SmallLoader />
                            ) :
                                <>
                                    {/* <img src={downloadbrokrage} alt="download" /> */}
                                    Download</>
                            }
                        </button>
                    </div>
                </div>

                <div className='brokerage-table'>
                    {props.loader ? (
                        <Loader />
                    ) :
                        <div className="scroll-table master_table personalised-table general-table">
                            {gridVal && gridVal?.length > 0 ? (
                                <table className="table" style={{ width: "100%" }}>
                                    <thead style={{ width: "99.95%" }}>
                                        <tr>
                                            <th>
                                                <span className='wrap-th'>
                                                    <span>Pack Type</span>
                                                </span>
                                            </th>
                                            <th>
                                                <span className='wrap-th'>
                                                    <span>Account Opening Commission</span>

                                                </span>
                                            </th>
                                            <th>
                                                <span className='wrap-th'>
                                                    <span>Status</span>

                                                </span>
                                            </th>
                                            <th>
                                                <span className='wrap-th'>
                                                    <span>Requested Date</span>

                                                </span>
                                            </th>
                                            <th>
                                                <span className='wrap-th'>
                                                    <span>Action</span>

                                                </span>
                                            </th>


                                        </tr>
                                    </thead>
                                    <tbody
                                        //  onScroll={(e) => handleScroll(e)} 
                                        id="per-table-body" style={{ height: "215px" }}
                                    >
                                        {gridVal?.length > 0 && gridVal.map((item, index) => (
                                            <tr key={index}>
                                                <td ><span>{item?.packType}</span></td>
                                                <td ><span>{item?.commission}</span></td>
                                                {/* <td><span>{item?.status || "-"}</span></td> */}
                                                <td >
                                                    <span
                                                        style={{
                                                            color:
                                                                item?.status?.toLowerCase() === "active"
                                                                    ? "#00BA00"
                                                                    : item?.status?.toLowerCase() === "in-active"
                                                                        ? "#FFA300"
                                                                        : "red", // default color
                                                        }}
                                                    >
                                                        {item?.status}
                                                    </span>
                                                </td>
                                                <td ><span>{item?.requestedDate}</span></td>

                                                <td >
                                                    {/* <span>{item?.fnolossPerc || "-"}</span> */}
                                                    <span
                                                        style={{
                                                            marginLeft: "10px",
                                                            backgroundColor: item?.status?.toLowerCase() === "active" ? "white" : "#ccc",
                                                            color: item?.status?.toLowerCase() === "active" ? "#1C74D0" : "#666666",
                                                            padding: "5px 10px",
                                                            cursor: item?.status?.toLowerCase() === "active" ? "pointer" : "not-allowed",
                                                            borderRadius: "4px",
                                                        }}
                                                        onClick={() => item?.status?.toLowerCase() === "active" ? handleDeactivate(item) : null}
                                                    >
                                                        Deactivate
                                                    </span>
                                                </td>

                                            </tr>
                                        ))
                                        }
                                        {props.scrollLoaderTable && (
                                            <div className="loader-center">
                                                <LoaderForSearch />
                                            </div>
                                        )}
                                    </tbody>
                                </table>
                            ) : noDataFound()
                            }
                        </div>
                    }
                </div>
            </div>
            <Modal
                show={deactivate}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="rm-model partner-modal"
            >
                {/* <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Are you sure you want to deactivate the pack?
                    </Modal.Title>
                    <button
                        type="button"
                        className="btn-close filter-closeBtn"
                        aria-label="Close"
                    >
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header> */}
                <Modal.Body>
                    <div className="modal-close-partner">
                        <button
                            type="button"
                            className="btn-close filter-closeBtn"
                            aria-label="Close"
                            onClick={() => setDeactivate(false)}
                        >
                            <span className="icon-close par-close-modal"></span>
                        </button>
                    </div>

                    <h4 className="section-title modal-par-title">
                        Are you sure you want to deactivate the pack?

                    </h4>
                    <div className="btn-yes-no partner">
                        <Button
                            className="yes-btn confirmation-btn"
                            style={{ padding: "4px 50px", background: "#FFFFFF", color: "#1C74D0" }}
                            onClick={() => deactivatefunction()}
                        >
                            Yes
                        </Button>
                        <Button
                            style={{ padding: "4px 50px" }}
                            className="no-btn confirmation-btn"
                            closeButton
                            onClick={() => {
                                setDeactivate(false)
                            }}
                        >
                            No
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
